




















































import { Component, Vue } from "vue-property-decorator";
import { deleteFolder, checkDelete, DeleteSystemFileFolderWithContentsForBackdoorUser } from "@/services/folders/folderService";

@Component
export default class FolderDeleteModal extends Vue {
    folderToBeDeleted: string = "";
    folderName: string = ""
    confirmFolderNameInput: string = "";
    isFolderNameConfirmed: boolean = false;

    open(folderId: string, name: string, isSystemFiles: boolean) {
        // Allow deletion of folder with its contents only for the system files
        if (isSystemFiles) {
            this.folderToBeDeleted = folderId;
            this.folderName = name;
            this.$bvModal.show("modal-deleteFolderWithContents");
        } else {
            checkDelete(folderId).then(response => {
                if (response) {
                    this.folderToBeDeleted = folderId;
                    this.folderName = name;
                    this.$bvModal.show("modal-deleteFolder");
                } else {
                    this.$bvModal.show("modal-deleteFolderNotAllowed");
                }
            });
        }
    }

    close() {
        this.$bvModal.hide("modal-deleteFolderNotAllowed");
    }

    decline() {
        this.$bvModal.hide("modal-deleteFolder");
        this.folderToBeDeleted = "";
        this.folderName = "";
    }

    confirm() {
        this.$bvModal.hide("modal-deleteFolder");
        deleteFolder(this.folderToBeDeleted).then(() => {
            this.$emit("confirm");
        });
        this.folderToBeDeleted = "";
        this.folderName = "";
    }

    deleteFolderWithContents() {
        this.$bvModal.hide("modal-deleteFolderWithContents");
        DeleteSystemFileFolderWithContentsForBackdoorUser(this.folderToBeDeleted).then(() => {
            this.$emit("confirm"); // Change current folder selection to root folder after deletion
        });
    }

    declineDeleteFolderWithContents() {
        this.$bvModal.hide("modal-deleteFolderWithContents");
    }

    resetFolderWithContentsState() {
        this.folderToBeDeleted = "";
        this.folderName = "";
        this.confirmFolderNameInput = "";
        this.isFolderNameConfirmed = false;
    }

    validateFolderName() {
        this.isFolderNameConfirmed = this.confirmFolderNameInput.trim().toLowerCase() === this.folderName.trim().toLowerCase();
    }
}
